import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { QueryParameters as SelfServeQueryParameters } from "@faire/web-api--source/routes/support/self-serve";
import { useEffect } from "react";

import { useNodeSetter } from "./useNodeSetter";
import { useSelectedNode } from "./useSelectedNode";
import { useTree } from "./useTree";

export const useFaireDirectWidgetChat = () => {
  const { tree } = useTree();
  const { faire_direct_widget_chat } = useQueryParams(
    SelfServeQueryParameters.parse
  );
  const { setLevel1Node, setLevel2Node } = useNodeSetter();
  const { level1Node, level2Node } = useSelectedNode();

  useEffect(() => {
    if (faire_direct_widget_chat !== "1") {
      return;
    }

    const level1NodeToSet = tree["FaireDirect"];
    const level2NodeToSet = tree["FaireDirectWidgetChat"];
    if (level1NodeToSet && level1Node?.id !== level1NodeToSet.id) {
      setLevel1Node(level1NodeToSet);
    }
    if (level2NodeToSet && level2Node?.id !== level2NodeToSet.id) {
      setLevel2Node(level2NodeToSet);
    }
  }, [
    level1Node,
    level2Node,
    setLevel1Node,
    setLevel2Node,
    tree,
    faire_direct_widget_chat,
  ]);
};
